module.exports = __webpack_public_path__ + "static/feature-2-55608335b7f6f87f1a297498578701f9.mp4";